import { Typography } from '@remarkable/ark-web';

import { SplitHorizontalLayout } from 'src/components';

import { useLingui } from '@lingui/react/macro';
import {
  useCheckoutForm,
  useCheckoutFormLocationDetails,
} from '../checkoutFormStore';

function WithLabel({
  children,
  label,
}: {
  children: React.ReactNode;
  label: string;
}) {
  return (
    <div className="w-full">
      <Typography variant="interface-sm" className="text-muted">
        {label}
      </Typography>
      <Typography variant="body-md">{children}</Typography>
    </div>
  );
}

export function CheckoutDetails() {
  const { t } = useLingui();
  const [checkoutFormState] = useCheckoutForm();
  const { country, province, state } = useCheckoutFormLocationDetails();

  const location = [country?.label, province, state].filter(Boolean).join(', ');

  return (
    <div className="flex w-full flex-col gap-8">
      <SplitHorizontalLayout>
        <WithLabel label={t`First name`}>
          {checkoutFormState.firstName}
        </WithLabel>

        <WithLabel label={t`Last name`}>{checkoutFormState.lastName}</WithLabel>
      </SplitHorizontalLayout>

      <WithLabel label={t`Address`}>
        {location} {checkoutFormState.postalCode}
      </WithLabel>
    </div>
  );
}
